module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "banner-info-icon.427979f1.png";